<template>
  <vx-card>
    <form @submit.prevent="checkValidation()" autocomplete="off">
      <label>
        {{ $t("labels.showing") }} {{ form_elements.length }}
        {{ $t("labels.images") }}
      </label>
      <div class="vx-row mb-4 mt-4">
        <div
          v-for="(element, index) in form_elements"
          :key="index"
          class="vx-col sm: w-full md:w-1/2 lg:w-1/3 xl:w-1/4 general-image-card pb-6 flex"
        >
          <vx-card>

            <div class="flex justify-center w-full" v-if="element.url">
              <div class="upload-img polaroid">
                <a :href="element.url" target="_blank">
                  <img :src="element.url" alt="Image" />
                </a>
              </div>
            </div>​
            <div>
              <div
                class="vx-row w-full mb-4"
                v-if="$store.state.userInfo.type === 'A' && element.uploader"
              >
                <div class="vx-col sm: w-1/2 font-bold">{{$t('labels.uploaded_by')}}:</div>
                <div class="vx-col sm: w-1/2">{{ element.uploader.name }}</div>
              </div>
              <div class="vx-row w-full mb-4">
                <div class="vx-col sm: w-1/2 font-bold">{{$t('labels.description')}}:</div>
                <div class="vx-col sm: w-1/2">{{ element.description }}</div>
              </div>
              <div class="vx-row w-full mb-4" v-if="element.sub_section">
                <div class="vx-col sm: w-1/2 font-bold">{{$t('labels.section')}}:</div>
                <div
                  class="vx-col sm: w-1/2"
                >{{ element.sub_section.parent.name ? element.sub_section.parent.name : '-' }}</div>
              </div>
              <div class="vx-row w-full mb-4" v-if="element.sub_section">
                <div class="vx-col sm: w-1/2 font-bold">{{$t('labels.sub_section')}}:</div>
                <div
                  class="vx-col sm: w-1/2"
                >{{ element.sub_section.name ? element.sub_section.name : '-' }}</div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </form>
  </vx-card>
</template>
​
<script>
import VueUploadMultipleImage from "vue-upload-multiple-image";

export default {
  components: {
    VueUploadMultipleImage
  },
  data() {
    return {
      id: this.$route.params.id,
      images: [],
      sub_section: null,
      sub_sections: [],
      selecetd_section: "",
      sections: [],
      cancel: "",
      form_elements: [
        {
          description: "",
          url: "",
          uploader: "",
          section_id: "",
          service_id: "",
          consultant_id: "",
          sub_section_drop: []
        }
      ]
    };
  },
  props: ["consultantId", "serviceId"],
  async mounted() {
    await this.getProject();
    await this.getSections();
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.sendImages();
        }
      });
    },
    updateSubsection(element, section) {
      this.sections.forEach(el => {
        if (el.id == section) {
          element.sub_section_drop = el.children;
        }
      });
      //fist clear selected subsection and its dropdown array
      element.sub_section_id = null;
      element.sub_section_drop = [];
      //set current v-select value as a selected_section
      this.selected_section = section;

      // get subsections for selected section
      let sections = this.sections;
      var selected_sections = sections.filter(function(el) {
        return el.id == section;
      });
      this.sections.forEach(el => {
        if (el.id == section) {
          element.sub_section_drop = el.children;
        }
      });
    },
    async sendImages() {
      let input = {
        images: this.form_elements
      };
      let url = "/projects/images/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#save-answer",
        true
      );
      if (response) {
        await this.getProject();
        await this.getSections();
      }
    },
    async getProject() {
      this.$vs.loading();
      let response = await this.getHTTPGetResponse(
        "/projects/get/" + this.$route.params.id
      );
      if (response) {
        let data = response.data;
        let project = data.project;
        let images = data.project.images;
        let serviceImages = [];
        images.forEach(el => {
          if (
            el.consultant_id === this.consultantId &&
            el.service_id === this.serviceId
          ) {
            serviceImages.push(el);
          }
        });
        this.form_elements = serviceImages;
      }
      this.$vs.loading.close();
    },
    addElement() {
      this.form_elements.push({
        description: "",
        url: "",
        section_id: "",
        sub_section_id: "",
        service_id: this.serviceId,
        consultant_id: this.consultantId
      });
    },
    removeElement(index) {
      this.form_elements.splice(index, 1);
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    async uploadImageSuccess(event, index) {
      var element = this.form_elements[index];
      var fileData = event.target.files;
      for (var i = 0; i < fileData.length; i++) {
        var input = new FormData();
        input.append("directory", "listing");
        input.append("attachment", event.target.files[i]);
        var response = await this.axios.post("s3/upload", input);
        if (response) {
          let data = response.data.data;
          var new_element = {
            ...element,
            url: data.url
          };
          this.form_elements.splice(index + i, i == 0 ? 1 : 0, new_element);

          this.$vs.notify({
            title: "Success.",
            text: response.data.message,
            color: "success",
            position: "top-right"
          });
        }
      }
    },
    getFileName(url) {
      var filename = url.substring(url.lastIndexOf("/") + 1);
      return filename;
    },
    clearFileName(index) {
      this.form_elements[index].url = "";
      // this.form_elements[index].description = "";
    },
    // API Integration for section listing
    async getSections() {
      let input = {
        only_parents: true,
        with_children: true
      };
      let response = await this.getHTTPPostResponse("/sections/list", input);
      if (response) {
        let sections = response.data.sections;

        this.sections = sections;
        await this.form_elements.forEach(element => {
          this.sections.forEach(el => {
            if (el.id == element.section_id) {
              element.sub_section_drop = el.children;
            }
          });
        });
      }
    }
  }
};
</script>
<style scoped>
.upload-img img {
  border-radius: 3px;
  width: 100%;
  height: 240px;
}

.upload-img,
img:hover {
  box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
}
div.polaroid {
  width: 100%;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 3px;
  position: relative;
}
.cancel-btn {
  position: absolute;
  right: 10px;
}
.vs-con-textarea {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  border-radius: 5px;
  /* margin-left: 23px; */
  /* background: rgba(var(--vs-dark), 1) !important; */
  /* width: 81%; */
  margin-bottom: 0 !important;
  box-shadow: none !important;
}
label {
  font-size: 18.48px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1) !important;
}
.design-btn {
  width: 180px;
  height: 180px;
  border: 1px dashed #c5c5c5;
  cursor: pointer;
  margin: 0;
}
.design-btn .feather-icon {
  top: 25.4%;
  left: 26.8%;
}
.design-btn .feather-icon svg {
  width: 80px;
  stroke: #c5c5c5;
  height: 80px;
}
.upload-user {
  font-size: 16px;
}
</style>
